import moment from 'moment'
import { RISK_TYPE_CAR, RISK_TYPE_HOME, RISK_TYPE_MOTO } from 'util/riskTypes'

class PolicyModifyDto extends Map {
    static fromJson(dataFromAPI) {
        const rootData = new PolicyModifyDto(Object.entries(dataFromAPI))

        const editableDataObj = rootData.get('editableData')
        const editableData = new PolicyModifyDto(Object.entries(editableDataObj))

        const risk = rootData.get('multiQuoteType')

        switch (risk) {
            case RISK_TYPE_CAR:
                return {
                    brand: editableData.get('brand'),
                    brokerDesc: editableData.get('brokerDesc'),
                    commission: editableData.get('commission'),
                    commissionPremium: Number(editableData.get('primaCommission')),
                    companyId: editableData.get('company'),
                    coverage: editableData.get('coverageLongName'),
                    customerId: editableData.get('clientId'),
                    downloadDocuments: rootData.get('downloadDocuments'),
                    installments: Number(editableData.get('dues')),
                    grossPremium: Number(editableData.get('premioTotal')),
                    assuredAmount: Number(editableData.get('insuredAmount')),
                    licensePlate: editableData.get('patent'),
                    model: editableData.get('model'),
                    infoAutoCode: editableData.get('infoAutoCode'),
                    gnc: Number(editableData.get('gnc')) || 0,
                    money: editableData.get('currency') === 'USD' ? 'U$S' : 'peso',
                    organizerDesc: editableData.get('organizerDesc'),
                    paymentMethod: editableData.get('paymentMethod'),
                    policyNumber: editableData.get('policyNumber'),
                    risk,
                    validFrom: editableData.get('validFrom'),
                    validTo: editableData.get('validTo'),
                    modelYear: Number(editableData.get('year')),
                }
            case RISK_TYPE_MOTO:
                return {
                    brand: editableData.get('brand'),
                    brokerDesc: editableData.get('brokerDesc'),
                    commission: editableData.get('commission'),
                    commissionPremium: Number(editableData.get('primaCommission')),
                    companyId: editableData.get('company'),
                    coverage: editableData.get('coverageLongName'),
                    customerId: editableData.get('clientId'),
                    downloadDocuments: rootData.get('downloadDocuments'),
                    installments: Number(editableData.get('dues')),
                    grossPremium: Number(editableData.get('premioTotal')),
                    assuredAmount: Number(editableData.get('insuredAmount')),
                    licensePlate: editableData.get('patent'),
                    model: editableData.get('model'),
                    infoAutoCode: editableData.get('infoAutoCode'),
                    money: editableData.get('currency') === 'USD' ? 'U$S' : 'peso',
                    organizerDesc: editableData.get('organizerDesc'),
                    paymentMethod: editableData.get('paymentMethod'),
                    policyNumber: editableData.get('policyNumber'),
                    risk,
                    validFrom: editableData.get('validFrom'),
                    validTo: editableData.get('validTo'),
                    modelYear: Number(editableData.get('year')),
                }
            case RISK_TYPE_HOME:
                return {
                    brokerDesc: editableData.get('brokerDesc'),
                    commission: editableData.get('commission'),
                    commissionPremium: Number(editableData.get('primaCommission')),
                    companyId: editableData.get('company'),
                    customerId: editableData.get('clientId'),
                    downloadDocuments: rootData.get('downloadDocuments'),
                    installments: Number(editableData.get('dues')),
                    grossPremium: Number(editableData.get('premioTotal')),
                    assuredAmount: Number(editableData.get('insuredAmount')),
                    money: editableData.get('currency') === 'USD' ? 'U$S' : 'peso',
                    organizerDesc: editableData.get('organizerDesc'),
                    paymentMethod: editableData.get('paymentMethod'),
                    policyNumber: editableData.get('policyNumber'),
                    risk,
                    validFrom: editableData.get('validFrom'),
                    validTo: editableData.get('validTo'),
                    street: editableData.get('street'),
                    streetNumber: editableData.get('number'),
                    floor: editableData.get('floor'),
                    apartment: editableData.get('apartment'),
                    locality: editableData.get('locality'),
                    province: editableData.get('province'),
                    description: editableData.get('description'),
                }
            default:
                return {
                    assetDescription: editableData.get('longName'),
                    assetTitle: editableData.get('shortName'),
                    brokerDesc: editableData.get('brokerDesc'),
                    commission: editableData.get('commission'),
                    commissionPremium: Number(editableData.get('primaCommission')),
                    companyId: editableData.get('company'),
                    customerId: editableData.get('clientId'),
                    downloadDocuments: rootData.get('downloadDocuments'),
                    installments: Number(editableData.get('dues')),
                    grossPremium: Number(editableData.get('premioTotal')),
                    assuredAmount: Number(editableData.get('insuredAmount')),
                    money: editableData.get('currency') === 'USD' ? 'U$S' : 'peso',
                    organizerDesc: editableData.get('organizerDesc'),
                    paymentMethod: editableData.get('paymentMethod'),
                    policyNumber: editableData.get('policyNumber'),
                    risk,
                    validFrom: editableData.get('validFrom'),
                    validTo: editableData.get('validTo'),
                }
        }
    }

    static toJSON(formData) {
        const data = new PolicyModifyDto(Object.entries(formData))

        const validFrom = moment(data.get('dateFrom'))
        const validTo = moment(data.get('dateTo'))
        const year = Number(data.get('modelYear'))
        const rawInfoAutoCode = data.get('infoAutoCode')
        const infoAutoCode = rawInfoAutoCode != null && rawInfoAutoCode !== ''
            ? String(rawInfoAutoCode)
            : null
        const insuredAmount = Number(data.get('assuredAmount'))
        const dues = Number(data.get('installments'))
        const commission = data.get('commission')
        const commissionPremium = Number(data.get('commissionPremium'))
        const grossPremium = data.get('grossPremium')

        const risk = data.get('riskId')

        const removedFilesString = data.get('removedFiles')
        const removedFiles =
            (removedFilesString?.length > 0 && removedFilesString?.split(',')) || []

        switch (risk) {
            case RISK_TYPE_CAR:
                return {
                    risk,
                    brand: data.get('brand'),
                    brokerDesc: data.get('brokerDesc'),
                    circulationDocument: data.get('circulationCardFileBase64'),
                    clientId: data.get('customerId'),
                    commission: String(commission),
                    company: data.get('companyId'),
                    coverageLongName: data.get('coverage'),
                    currency: data.get('money') === 'U$S' ? 'USD' : 'ARS',
                    dues: Number.isInteger(dues) ? dues : null,
                    gnc: Number(data.get('gnc')) || 0,
                    insuredAmount: Number.isNaN(insuredAmount) ? null : insuredAmount,
                    invoice: data.get('billFileBase64'),
                    mercosur: data.get('mercosurCardFileBase64'),
                    model: data.get('model'),
                    infoAutoCode,
                    organizerDesc: data.get('organizerDesc'),
                    other: data.get('otherFileBase64'),
                    patent: data.get('licensePlate'),
                    paymentMethod: data.get('paymentMethod') || 'empty',
                    policy: data.get('policyFileBase64'),
                    policyNumber: data.get('policyNumber'),
                    premioTotal: grossPremium !== '' ? grossPremium : null,
                    primaCommission: Number.isNaN(commissionPremium) ? null : commissionPremium,
                    removeFiles: removedFiles,
                    validFrom: validFrom.isValid() ? validFrom.format('YYYY-MM-DD') : null,
                    validTo: validTo.isValid() ? validTo.format('YYYY-MM-DD') : null,
                    year: Number.isInteger(year) ? year : null,
                    paymentNumber: null,
                    proposal: null,
                }
            case RISK_TYPE_MOTO:
                return {
                    risk,
                    brand: data.get('brand'),
                    brokerDesc: data.get('brokerDesc'),
                    circulationDocument: data.get('circulationCardFileBase64'),
                    clientId: data.get('customerId'),
                    commission: String(commission),
                    company: data.get('companyId'),
                    coverageLongName: data.get('coverage'),
                    currency: data.get('money') === 'U$S' ? 'USD' : 'ARS',
                    dues: Number.isInteger(dues) ? dues : null,
                    insuredAmount: Number.isNaN(insuredAmount) ? null : insuredAmount,
                    invoice: data.get('billFileBase64'),
                    mercosur: data.get('mercosurCardFileBase64'),
                    model: data.get('model'),
                    infoAutoCode,
                    organizerDesc: data.get('organizerDesc'),
                    other: data.get('otherFileBase64'),
                    patent: data.get('licensePlate'),
                    paymentMethod: data.get('paymentMethod') || 'empty',
                    policy: data.get('policyFileBase64'),
                    policyNumber: data.get('policyNumber'),
                    premioTotal: grossPremium !== '' ? grossPremium : null,
                    primaCommission: Number.isNaN(commissionPremium) ? null : commissionPremium,
                    removeFiles: removedFiles,
                    validFrom: validFrom.isValid() ? validFrom.format('YYYY-MM-DD') : null,
                    validTo: validTo.isValid() ? validTo.format('YYYY-MM-DD') : null,
                    year: Number.isInteger(year) ? year : null,
                    paymentNumber: null,
                    proposal: null,
                }
            case RISK_TYPE_HOME:
                return {
                    brokerDesc: data.get('brokerDesc'),
                    clientId: data.get('customerId'),
                    commission: String(commission),
                    company: data.get('companyId'),
                    currency: data.get('money') === 'U$S' ? 'USD' : 'ARS',
                    clause: data.get('clauseFileBase64'),
                    invoice: data.get('billFileBase64'),
                    other: data.get('otherFileBase64'),
                    dues: Number.isInteger(dues) ? dues : null,
                    insuredAmount: Number.isNaN(insuredAmount) ? null : insuredAmount,
                    organizerDesc: data.get('organizerDesc'),
                    paymentMethod: data.get('paymentMethod') || 'empty',
                    policy: data.get('policyFileBase64'),
                    policyNumber: data.get('policyNumber'),
                    premioTotal: grossPremium !== '' ? grossPremium : null,
                    primaCommission: Number.isNaN(commissionPremium) ? null : commissionPremium,
                    removeFiles: removedFiles,
                    risk,
                    validFrom: validFrom.isValid() ? validFrom.format('YYYY-MM-DD') : null,
                    validTo: validTo.isValid() ? validTo.format('YYYY-MM-DD') : null,
                    street: data.get('street'),
                    number: data.get('streetNumber'),
                    floor: data.get('floor'),
                    apartment: data.get('apartment'),
                    locality: data.get('locality'),
                    localityCode: null,
                    province: data.get('province'),
                    provinceCode: null,
                    description: data.get('description'),
                    paymentNumber: null,
                    proposal: null,
                }
            default:
                return {
                    brokerDesc: data.get('brokerDesc'),
                    clientId: data.get('customerId'),
                    commission: String(commission),
                    company: data.get('companyId'),
                    currency: data.get('money') === 'U$S' ? 'USD' : 'ARS',
                    clause: data.get('clauseFileBase64'),
                    invoice: data.get('billFileBase64'),
                    other: data.get('otherFileBase64'),
                    dues: Number.isInteger(dues) ? dues : null,
                    insuredAmount: Number.isNaN(insuredAmount) ? null : insuredAmount,
                    longName: data.get('assetDescription'),
                    organizerDesc: data.get('organizerDesc'),
                    paymentMethod: data.get('paymentMethod') || 'empty',
                    policy: data.get('policyFileBase64'),
                    policyNumber: data.get('policyNumber'),
                    premioTotal: grossPremium !== '' ? grossPremium : null,
                    primaCommission: Number.isNaN(commissionPremium) ? null : commissionPremium,
                    removeFiles: removedFiles,
                    risk,
                    shortName: data.get('assetTitle'),
                    validFrom: validFrom.isValid() ? validFrom.format('YYYY-MM-DD') : null,
                    validTo: validTo.isValid() ? validTo.format('YYYY-MM-DD') : null,
                    paymentNumber: null,
                    proposal: null,
                }
        }
    }
}

export default PolicyModifyDto
